import { ChakraV3 } from '@piccolohealth/ui';
import React from 'react';
import { v3Theme } from './v3/v3Theme';

export const ChakraProvider = (props: React.PropsWithChildren) => {
  return <ChakraV3.ChakraProvider value={v3Theme}>{props.children}</ChakraV3.ChakraProvider>;
};
